export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7580.bd655209.jpg";